import { moduleProviderFactory } from 'core/providers';
import { ImportReferenceTypeEdit, ImportReferenceTypeList } from 'application/import-reference-type/pages';

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: 'master.app.main.import-reference-type',
                pattern: '/import-reference-types',
                children: [
                    {
                        name: 'master.app.main.import-reference-type.list',
                        pattern: '',
                        tabTitle: 'IMPORT_REFERENCE_TYPE.LIST.TITLE_SECONDARY',
                        component: ImportReferenceTypeList,
                        data: {
                            title: 'IMPORT_REFERENCE_TYPE.LIST.TITLE_SECONDARY'
                        }
                    },
                    {
                        name: 'master.app.main.import-reference-type.create',
                        pattern: '/create',
                        tabTitle: 'Create Reference Type',
                        component: ImportReferenceTypeEdit,
                        authorization: 'importReferenceSection.create',
                        data: {
                            title: 'IMPORT_REFERENCE_TYPE.CREATE.TITLE'
                        },
                    },
                    {
                        name: 'master.app.main.import-reference-type.edit',
                        pattern: '/edit/:id',
                        tabTitle: 'Edit Reference Type',
                        component: ImportReferenceTypeEdit,
                        authorization: 'importReferenceSection.update',
                        data: {
                            title: 'IMPORT_REFERENCE_TYPE.EDIT.TITLE'
                        },
                    }                 
                ]
            }
        ],
        menu: [
            {
                title: 'MENU.MASTER_DATA',
                order: 7,
                icon: 'database',
                authorization: 'administrationSection.read',
                subMenu: [
                    {
                        title: 'MENU.IMPORT_REFERENCE_TYPES_SUB',
                        route: 'master.app.main.import-reference-type.list',
                        order: 14,
                    }                    
                ]
            }
        ]
    });
})();
